import React from "react";
import PropTypes from "prop-types";

import "./Subtitle.css";

function Subtitle(props) {
  const { lightBg, lightText, subtitle, topLine } = props;

  return (
    <>
      <div
        className={
          lightBg ? "subtitle__section" : "subtitle__section subtitle--darkBg"
        }
      >
        <div className="subtitle__container">
          <div
            className={
              lightBg
                ? "subtile__top-line"
                : "subtile__top-line subtile__top-line--dark"
            }
          >
            {topLine}
          </div>
          <h1
            className={
              lightText ? "subtitle__text" : "subtitle__text subtitle--dark"
            }
          >
            {subtitle}
          </h1>
        </div>
      </div>
    </>
  );
}

Subtitle.propTypes = {
  lightBg: PropTypes.bool,
  lightText: PropTypes.bool,
  subtitle: PropTypes.string,
  topLine: PropTypes.string,
};

export default Subtitle;
